import { computed, inject, Injectable, signal } from "@angular/core";
import { EventType } from '@interfaces';
import { AppService, FuncService } from "../../../../services";

@Injectable({ providedIn: 'root' })
export class EventAddDialogDataService {

	private func = inject(FuncService);
	private app = inject(AppService);
	public canEdit = computed(() => this.app.data().permissions.canFacilitateCohorts);


	public data = signal<{ eventType: EventType, acc: { name: string, accId: number, facilitatorPersonId: number, facilitatorName: string } | undefined, languageId: number } | undefined>(undefined);

	public async loadData(data: {
		eventTypeId: number,
		languageId: number,
		accId?: number,
	}): Promise<void> {
		const { eventType, accelerator } = await this.func.event.getAddDialogData({ eventTypeId: data.eventTypeId, accId: data.accId });
		this.data.set({ eventType, acc: accelerator ? { name: accelerator.name, accId: accelerator.accId, facilitatorName: accelerator.facilitatorName, facilitatorPersonId: accelerator.facilitatorPersonId } : undefined, languageId: accelerator ? accelerator.languageId : data.languageId });
	}


	public async addEvent(values: { eventTypeId: number, languageId: number, accId?: number, startUTC: number, endUTC: number, toolStartUTC: number, toolEndUTC: number, link?: string, publicNotes?: string, hostPersonId: number, venueId?: number, }) {
		return await this.func.event.add({ values });
	}

}